module.exports = __webpack_public_path__ + "img/icon-package-network-light.3d70b66.svg";